import { addError } from "@wayflyer/blackbox-fe";

declare const window: any;

export function showMessageComposer() {
  window.Intercom("show");
}

export const handleContactTeam = () => {
  try {
    showMessageComposer();
  } catch (e) {
    addError("Intercom chat not opening >>", e as object);
    // Fall back to email
    window.open("mailto:support@wayflyer.com", "_blank");
  }
};
